import { render, staticRenderFns } from "./RetornarItemModal.vue?vue&type=template&id=df5949b8&scoped=true"
import script from "./RetornarItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RetornarItemModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RetornarItemModal.vue?vue&type=style&index=0&id=df5949b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5949b8",
  null
  
)

export default component.exports